export default[
    
    {
        path: '/employer',
        name: 'employer3',
        component: () => import('../components/website/employer3/Employer.vue'),
        meta: { requiresAuth: false, hideForAuth:true , showFor:'admin'}
    },

];